import React from 'react';
import css from './image.module.scss';

export function Image(props) {
  return (
    <div className={css(props)} style={style(props)}>
      { props.children }
    </div>
  );
}

Image.Loader = function Loader(props) {
  return (
    <img {...props} className={css.hide} />
  );
}

function style({ src }) {
  if (src) {
    return {
      backgroundImage: `url(${src})`
    }
  }
}
